import React, { useState } from 'react';
import styled from 'styled-components';
import AdminSidebar from './AdminSidebar';

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: #f8f9fa;
`;

const MainContent = styled.main`
  flex: 1;
  margin-left: 280px;
  transition: margin-left 0.3s ease;
  
  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

const Header = styled.header`
  position: sticky;
  top: 0;
  background: white;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #dee2e6;
  display: none;
  align-items: center;
  gap: 1rem;
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  
  @media (max-width: 768px) {
    display: flex;
  }
`;

const MenuButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
`;

const HeaderTitle = styled.h1`
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
  color: #000000;
`;

const ContentArea = styled.div`
  padding: 2rem;
  min-height: calc(100vh - 73px);
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

interface DashboardLayoutProps {
  children: React.ReactNode;
  title?: string;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ 
  children, 
  title = 'H_B' 
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  return (
    <LayoutContainer>
      <AdminSidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
      />
      
      <MainContent>
        <Header>
          <MenuButton onClick={() => setSidebarOpen(true)}>
            ☰
          </MenuButton>
          <HeaderTitle>{title}</HeaderTitle>
        </Header>
        
        <ContentArea>
          {children}
        </ContentArea>
      </MainContent>
    </LayoutContainer>
  );
};

export default DashboardLayout;

